var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "20px",
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Work-order",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MVP-Home-Page---1-passes-pending-approval",
    transform: "translate(-32.000000, -340.000000)",
    fill: "#4C4C4C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_list-:-30px",
    transform: "translate(32.000000, 340.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.57142857,3.75732332 L2.57142857,16.2426767 C2.57142857,16.9374214 3.15104978,17.5 3.86811026,17.5 L14.1318897,17.5 C14.8464036,17.5 15.4285714,16.9352808 15.4285714,16.2426767 L15.4285714,3.75732332 C15.4285714,3.06257856 14.8489502,2.5 14.1318897,2.5 L3.86811026,2.5 C3.1535964,2.5 2.57142857,3.06471916 2.57142857,3.75732332 Z M0,3.75732332 C0,1.68274127 1.73473455,-2.84217094e-14 3.86811026,-2.84217094e-14 L14.1318897,-2.84217094e-14 C16.2681488,-2.84217094e-14 18,1.68092947 18,3.75732332 L18,16.2426767 C18,18.3172587 16.2652654,20 14.1318897,20 L3.86811026,20 C1.73185121,20 0,18.3190705 0,16.2426767 L0,3.75732332 Z",
    id: "shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33333333,15.170355 L11.6666667,15.170355 C12.4030463,15.170355 13,14.5725757 13,13.8351775 C13,13.0977793 12.4030463,12.5 11.6666667,12.5 L6.33333333,12.5 C5.59695367,12.5 5,13.0977793 5,13.8351775 C5,14.5725757 5.59695367,15.170355 6.33333333,15.170355 Z",
    id: "shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33333333,11.170355 L11.6666667,11.170355 C12.4030463,11.170355 13,10.5725757 13,9.8351775 C13,9.09777933 12.4030463,8.5 11.6666667,8.5 L6.33333333,8.5 C5.59695367,8.5 5,9.09777933 5,9.8351775 C5,10.5725757 5.59695367,11.170355 6.33333333,11.170355 Z",
    id: "shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33333333,7.170355 L11.6666667,7.170355 C12.4030463,7.170355 13,6.57257567 13,5.8351775 C13,5.09777933 12.4030463,4.5 11.6666667,4.5 L6.33333333,4.5 C5.59695367,4.5 5,5.09777933 5,5.8351775 C5,6.57257567 5.59695367,7.170355 6.33333333,7.170355 Z",
    id: "shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassIcon);
export default __webpack_public_path__ + "static/media/PassIcon.578d840672f98e16b3a348ab3fc34919.svg";
export { ForwardRef as ReactComponent };